<template>
	<div class="im-route-table">
		<div class="im-route-table__title">
			<section>
				<span>优先级：</span>
				<p>
					<span class="weight" v-if="!rows.vipGroup">无</span>
					<span class="level" v-else>
						<svg-icon icon-class="level" class="forth"></svg-icon>
						<span class="num">{{rows.vipGroupLevel}}</span>
					</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{rows.vipGroupName}}</span></p>
			</section>
			<section v-show="rows.vipGroup && rows.skillGroupList.length > 0">
				<el-button type="text" @click="onEdit">编辑</el-button>
				<el-divider direction="vertical"></el-divider>
				<el-popconfirm
				  confirm-button-text='好的'
				  cancel-button-text='我再想想'
				  icon="el-icon-info"
				  icon-color="red"
				  title="确认恢复该【优先组】至普通组？"
				  @confirm="onDelete"
				>
				 <el-button slot="reference" type="text">删除</el-button>
				</el-popconfirm>
				
			</section>
		</div>
		<div class="im-route-table__box">
			<table class="table">
				<thead class="thead-dark">
					<tr>
						<th scope="col">技能组</th>
						<th scope="col">权重
							 <el-popover
								placement="bottom-start"
								width="522"
								trigger="hover"
								content="当客人存在排队情况时，技能组权重越高，组内复合技能的客服接待的客人数量越多。">
							   <svg-icon icon-class="question" slot="reference"></svg-icon>
							  </el-popover>
							 <span class="reset" @click="onReset">重置</span></th>
						<th scope="col">操作</th>
					</tr>
				</thead>
				<draggable v-model="tableData" tag="tbody" group="people" animation="150" handle=".mover" @add="onDraggle">
					<tr v-for="(item,index) in tableData" :key="index" class="tr-row">
						<td scope="col">{{ item.skillName }}</td>
						<td scope="col"> <el-input-number v-model="item.weight" :min="1" size="mini" @change="onChange(item)"></el-input-number></td>
						<td scope="col"><svg-icon icon-class="move" class="mover"></svg-icon></td>
					</tr>
				</draggable>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['rows'],
		watch:{
			'rows':{
				handler(val){
					this.tableData = val.skillGroupList;
				},
				immediate:true,
				deep:true
			}
		},
		data() {
			return {
				tableData:[]
			}
		},
		methods: {
			onReset(){
				let that = this;
				this.$confirm("重置后，该列表技能组权重相同，按照轮询分配进线，是否继续", "确认要重置该技能组权重？", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
						customClass: "confirm-element-model"
					}).then(() => {
						let lists = JSON.parse(JSON.stringify(this.tableData));
						for(let item of lists){
							item.weight = 1;
						}
						this.updateTable(lists);
					}).catch(() => {
						
					});
			},
			onDraggle(event) {
				let lists = JSON.parse(JSON.stringify(this.tableData));
				for(let item of lists){
					item.vipGroup = this.rows.vipGroupName != '普通组' ? this.rows.vipGroup : '';
					item.vipGroupName = this.rows.vipGroupName;
					item.vipGroupLevel = this.rows.vipGroupLevel
				}
				this.updateTable(lists)
				
			},
			updateTable(data){
				let params = {
						brand:this.rows.brand,
						childBrand:this.rows.childBrand,
						enabledExclusiveAgent:this.rows.enabledExclusiveAgent,
						skillGroupList:data,
				}
				this.$api.updateImServiceRouterItem(params).then(res => {
					if(res.errcode == 0){
						this.$message.success('操作成功');
						this.$emit('getData','noloading')
					}
				})
			},
			onChange(row){
				this.updateTable(this.tableData);
			},
			onEdit(){
				this.$emit('onEdit',this.rows)
			},
			onDelete(){
				let result = [];
				this.tableData.map(item => {
					item.vipGroup = '';
					item.vipGroupName = '普通组';
					result.push(item)
				})
				this.updateTable(result)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.im-route-table {
		width: 100%;
		margin-top: 28px;
		.mover {
			color: #000;
			cursor: move;
		}
		&__box {
			padding: 0 4px;
			border: 1px solid #E8E8E8;
			border-radius: 4px 4px 0px 0px;
			margin-top: 12px;
			table {
				width: 100%;
				border-collapse: collapse;
				cursor: pointer;
			}
			.thead-dark {
				height: 36px;
				background: #F6F7F9;
				color: #3C4353;
				font-size: 14px;
			
				th {
					width: calc(100% / 3);
					height: 36px;
					line-height: 36px;
					display: inline-block;
				}
				tr {
					border: none;
				}
				.reset {
					color: #337EFF;
					margin-left: 30px;
				}
			}
			
			tbody {
				width: 100%;
				tr {
					width: 100%;
					height: 46px;
					line-height: 46px;
					display: flex;
					color: #838A9D;
					border-bottom: 1px solid rgba(0, 0, 0, .1);
					td {
						width: 100%;
						text-align: center;
					}
					&:nth-last-of-type(1){
						border: none;
					}
				}
			}
		}
		&__title {
			color: #3C4353;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			section,p {
				display: flex;
				align-items: center;
			}
			.weight {
				font-weight: 600;
			}
			.level {
				width: 20px;
				height: 28px;
				margin: 0 5px;
				position: relative;
				display: flex;
				.svg-icon {
					width: 100%;
					height: 100%;
					&.top {
						color: #FF504D;
					}
					&.second {
						color: #F29522;	
					}
					&.third {
						color: #FFC548;	
					}
					&.forth {
						color: #47B267;	
					}
				}
				.num {
					font-size: 12px;
					color: #fff;
					position: absolute;
					left: 6px;
					font-style:italic ;
					transform: scale(.8);
				}
			}
		}
	
	}
</style>
